var _defs, _path, _path2, _path3, _path4, _path5, _g, _path6, _path7, _g2, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _g3, _g4, _g5, _g6, _g7, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _rect29, _rect30, _rect31, _path16, _g8, _path17, _path18, _path19, _g9, _path20, _g10, _path21, _g11, _g12;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFerme({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 161.074,
    height: 84.34,
    viewBox: "0 0 161.074 84.34",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 7.767,
    y1: -0.107,
    x2: 7.767,
    y2: 1.215,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.074,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c9c3bc"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_16099",
    "data-name": "Group 16099",
    transform: "translate(-626.926 -156.83)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15960",
    "data-name": "Group 15960",
    transform: "translate(470.821 -59.59)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_8802",
    "data-name": "Path 8802",
    d: "M880.1,868.041s.906-2.534,3.072-2.252c0,0,3.145-4.223,6.5-.563,0,0,3.565-.907,6.205.785a6.638,6.638,0,0,1,2.342,2.312Z",
    transform: "translate(-684.011 -611.565)",
    fill: "#f8fcff",
    opacity: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_8803",
    "data-name": "Path 8803",
    d: "M642.6,692.217s1.1-3.07,3.722-2.729c0,0,3.81-5.117,7.873-.682,0,0,4.319-1.1,7.518.951a8.043,8.043,0,0,1,2.837,2.8Z",
    transform: "translate(-459.632 -444.59)",
    fill: "#f8fcff",
    opacity: 0.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_8804",
    "data-name": "Path 8804",
    d: "M1308.421,655.636a5.134,5.134,0,0,1,4.941-2.389s5.058-4.481,10.452-.6c0,0,5.734-.962,9.98.833a9.429,9.429,0,0,1,3.766,2.452Z",
    transform: "translate(-1088.678 -410.642)",
    fill: "#f8fcff",
    opacity: 0.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_8805",
    "data-name": "Path 8805",
    d: "M352.614,293.765c-.1.443-.221.9-.351,1.352s-.273.937-.442,1.418c-.078.233-.169.468-.247.7-.273.742-.585,1.508-.962,2.3-.117.26-.234.533-.364.794-.033.081-.07.163-.11.244-.023.048-.048.1-.073.145H334.6l-4.526-.012H289.555l-5.726-.006h-.018l-6.033-.007H246.522l-13.03-.013H209.927l-.024-.063c0-.013-.009-.027-.016-.043l-.078-.206-.013-.026v-.013a.048.048,0,0,1-.013-.026,3.614,3.614,0,0,1-.143-.364c-.026-.065-.052-.144-.091-.221V299.7l-.013-.013c-.179-.464-.4-1.068-.656-1.8q-.034-.1-.07-.2c-.191-.552-.4-1.169-.626-1.85-.533-1.651-1.145-3.667-1.743-5.943-.234-.9-.468-1.834-.69-2.809-.13-.563-.261-1.15-.387-1.742q-.054-.26-.107-.521c-.23-1.109-.446-2.251-.641-3.419-.257-1.533-.478-3.109-.646-4.709q-.125-1.178-.21-2.372c0-.021,0-.042,0-.063s0-.043,0-.064c-.077-1.12-.125-2.249-.14-3.376q-.017-1.361.033-2.721c.026-.611.065-1.223.1-1.834.1-1.3.26-2.6.481-3.862.143-.858.325-1.717.533-2.549a28.932,28.932,0,0,1,2.106-5.839c.325-.637.663-1.261,1.041-1.873.845-1.392,1.7-2.692,2.575-3.914h.013c.455-.65.91-1.261,1.365-1.847a48.4,48.4,0,0,1,5.176-5.748c21.392-20.014,45.919-.7,61.1-14.136,14.838-13.121,42.6-13.316,55.022-1.209.234.234.481.468.715.728a20.173,20.173,0,0,1,4.514,7.473,21.494,21.494,0,0,1,1.072,7.2q-.006.411-.026.83a27.73,27.73,0,0,1-.435,3.694q-.232,1.264-.586,2.583a43.018,43.018,0,0,1-2.444,6.633q-.157.331-.312.663c-3.394,7.1-.6,11.353,3.681,15.241,2.639,2.406,5.826,4.669,8.479,7.374.351.364.689.728,1.027,1.105.13.15.257.3.383.453.354.428.7.865,1.021,1.315q.248.35.478.712a15.932,15.932,0,0,1,1.2,2.244,14.651,14.651,0,0,1,.616,1.709,14.44,14.44,0,0,1,.479,2.37A18.092,18.092,0,0,1,352.614,293.765Z",
    transform: "translate(-44.88)",
    fill: "rgba(16,135,87,0.3)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_8806",
    "data-name": "Path 8806",
    d: "M315.152,1291.186H268.145l-19.6-.013H213.111l-.061-.107-.117-.206-.019-.026v-.013s-.019-.013-.019-.026a3.033,3.033,0,0,1-.215-.364,2.268,2.268,0,0,0-.137-.221v-.026l-.019-.013c-.268-.464-.6-1.069-.986-1.8l-.105-.2c-.191-.552-.4-1.17-.626-1.85-.533-1.651-1.145-3.667-1.743-5.943-.234-.9-.468-1.833-.69-2.809-.13-.563-.261-1.15-.387-1.742q-.054-.261-.107-.521c-.23-1.109-.446-2.251-.641-3.419-.383-2.286-.685-4.667-.856-7.081,15.221.785,44.563,2.849,66.633,7.779,31.142,6.955,38.838,8.078,52.031,9.326C332.43,1282.61,324.006,1287.242,315.152,1291.186Z",
    transform: "translate(-47.501 -990.489)",
    fill: "#f9d37d"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_15234",
    "data-name": "Group 15234",
    transform: "translate(233.113 263.728)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8807",
    "data-name": "Path 8807",
    d: "M1674.251,1192.283l-1.1,21.584h1.1l.5-21.584Z",
    transform: "translate(-1666.375 -1185.699)",
    fill: "#f8fcff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8808",
    "data-name": "Path 8808",
    d: "M1694.715,1077.685l.28,1.329,5.021-5.959Z",
    transform: "translate(-1686.752 -1073.055)",
    fill: "#f8fcff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8809",
    "data-name": "Path 8809",
    d: "M1704.215,1184.058l-1.354-.1,4.324,6.483Z",
    transform: "translate(-1694.447 -1177.832)",
    fill: "#f8fcff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8810",
    "data-name": "Path 8810",
    d: "M1557.518,1186.028l.786-1.108-7.785.353Z",
    transform: "translate(-1550.52 -1178.742)",
    fill: "#f8fcff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_153",
    "data-name": "Ellipse 153",
    cx: 0.607,
    cy: 0.607,
    r: 0.607,
    transform: "translate(7.299 5.796) rotate(-22.5)",
    fill: "#f8fcff"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_8811",
    "data-name": "Path 8811",
    d: "M628.207,1315.176s-40.285-11.046-52.985-12.159-.534,1.488-.534,1.488,34.476,9.07,42.541,12.809S628.207,1315.176,628.207,1315.176Z",
    transform: "translate(-390.504 -1026.327)",
    fill: "#ffbe00"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_8812",
    "data-name": "Path 8812",
    d: "M530.822,1328.589s-34.832-16.713-46.207-19.85-.733,1.248-.733,1.248,29.873,13.957,36.593,18.678S530.822,1328.589,530.822,1328.589Z",
    transform: "translate(-305.405 -1030.926)",
    fill: "#ffbe00"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_15235",
    "data-name": "Group 15235",
    transform: "translate(206.285 268.965)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8813",
    "data-name": "Path 8813",
    d: "M1166,1265.46l-.9,17.667h.9l.407-17.667Z",
    transform: "translate(-1159.557 -1260.07)",
    fill: "#f8fcff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8814",
    "data-name": "Path 8814",
    d: "M1182.753,1171.659l.229,1.088,4.11-4.878Z",
    transform: "translate(-1176.235 -1167.869)",
    fill: "#f8fcff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8815",
    "data-name": "Path 8815",
    d: "M1190.53,1258.727l-1.109-.083,3.539,5.307Z",
    transform: "translate(-1182.534 -1253.631)",
    fill: "#f8fcff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8816",
    "data-name": "Path 8816",
    d: "M1070.455,1260.34l.644-.906-6.372.289Z",
    transform: "translate(-1064.727 -1254.377)",
    fill: "#f8fcff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8817",
    "data-name": "Path 8817",
    d: "M1175.666,1250.145a.5.5,0,1,1,.5.5A.5.5,0,0,1,1175.666,1250.145Z",
    transform: "translate(-1169.539 -1245.132)",
    fill: "#f8fcff"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_9052",
    "data-name": "Path 9052",
    d: "M2359.751,621.868c0,.274-.012.551-.026.83a27.661,27.661,0,0,1-.435,3.694l-17.3-.227s1.565-3.7,5.309-3.284c0,0,5.435-6.159,11.231-.821C2358.534,622.059,2358.993,621.961,2359.751,621.868Z",
    transform: "translate(-2065.171 -381.181)",
    fill: "#f8fcff"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_9053",
    "data-name": "Path 9053",
    d: "M1644.95,386.74a2.822,2.822,0,0,1,2.749-1.734s2.815-3.252,5.816-.434a9.128,9.128,0,0,1,5.553.6,5.522,5.522,0,0,1,2.1,1.78Z",
    transform: "translate(-1406.622 -157.78)",
    fill: "#f8fcff"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Path_9054",
    "data-name": "Path 9054",
    d: "M464.191,895.959a3.014,3.014,0,0,1,2.937-1.853s3.007-3.475,6.214-.463c0,0,3.409-.746,5.933.646a5.9,5.9,0,0,1,2.239,1.9Z",
    transform: "translate(-291.072 -638.662)",
    fill: "#f8fcff"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Path_9055",
    "data-name": "Path 9055",
    d: "M382.463,794.7a2.307,2.307,0,0,1,2.248-1.418s2.3-2.659,4.755-.355a7.464,7.464,0,0,1,4.54.494,4.516,4.516,0,0,1,1.713,1.456Z",
    transform: "translate(-213.857 -543.786)",
    fill: "#f8fcff"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Path_9056",
    "data-name": "Path 9056",
    d: "M2477.188,1570.185a20.82,20.82,0,0,1-.423,2.582c0,.018-.008.037-.014.056a59.349,59.349,0,0,0-13.48,6.756h-11.346C2453.569,1578.522,2461.584,1574.085,2477.188,1570.185Z",
    transform: "translate(-2169.031 -1279.002)",
    fill: "#6e9e63"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Path_9149",
    "data-name": "Path 9149",
    d: "M298.164,1634.093h-15.5l-.006-.017-.078-.206-.013-.026v-.013a.047.047,0,0,1-.013-.026,3.571,3.571,0,0,1-.143-.364c-.026-.065-.052-.144-.091-.221v-.027l-.013-.012c-.179-.464-.4-1.069-.656-1.8-.023-.066-.046-.133-.07-.2-.192-.552-.4-1.17-.626-1.85-.1-.32-.209-.654-.318-1a9.5,9.5,0,0,1,5.316-.142,6.733,6.733,0,0,1,2.537,1.478c1.227,1.116,1.733,2.22,3.161,1.79a5.16,5.16,0,0,1,1.237-.19C295.191,1631.165,298.37,1632.135,298.164,1634.093Z",
    transform: "translate(-117.658 -1333.498)",
    fill: "#108757"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_148624",
    "data-name": "Rectangle 148624",
    d: "M.214,0H160.86a.214.214,0,0,1,.214.214v0a.214.214,0,0,1-.214.214H.214A.214.214,0,0,1,0,.214v0A.214.214,0,0,1,.214,0Z",
    transform: "translate(156.105 300.333)",
    fill: "#2e3552"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_16100",
    "data-name": "Group 16100",
    transform: "translate(250.898 263.729)"
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "Path_14045",
    "data-name": "Path 14045",
    d: "M326.926,292.792l-5.584,2.673-1.917,4.208h1.184l6.728-3.441,2.016-3.109Z",
    transform: "translate(-319.424 -292.792)",
    fill: "#332c22"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_15604",
    "data-name": "Group 15604",
    transform: "translate(1.184 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14046",
    "data-name": "Path 14046",
    d: "M323.859,296.056l6.518-3.264,6.445,3.264,1.573,3.617V314.3H322.286V299.674Z",
    transform: "translate(-322.286 -292.792)",
    fill: "#fff2dc"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group_15605",
    "data-name": "Group 15605",
    transform: "translate(16.85 0.382)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14047",
    "data-name": "Path 14047",
    d: "M361.695,296.569l26.831-2.853,6.182,2.853,1.523,3.617v14.622H360.172V300.186Z",
    transform: "translate(-360.172 -293.717)",
    fill: "#efdec7"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Group_15606",
    "data-name": "Group 15606",
    transform: "translate(4.635 8.469)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_148706",
    "data-name": "Rectangle 148706",
    width: 9.275,
    height: 13.034,
    fill: "#d3c2a9"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Group_15607",
    "data-name": "Group 15607",
    transform: "translate(4.635 8.469)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_148707",
    "data-name": "Rectangle 148707",
    width: 8.856,
    height: 13.034,
    fill: "#c6af91"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Group_15608",
    "data-name": "Group 15608",
    transform: "translate(8.985 8.469)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_148708",
    "data-name": "Rectangle 148708",
    width: 0.157,
    height: 13.034,
    fill: "#d3c2a9"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15609",
    "data-name": "Group 15609",
    transform: "translate(12.994 8.469)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_148709",
    "data-name": "Rectangle 148709",
    width: 0.157,
    height: 13.034,
    fill: "#d3c2a9"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15610",
    "data-name": "Group 15610",
    transform: "translate(12.732 8.469)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_148710",
    "data-name": "Rectangle 148710",
    width: 0.157,
    height: 13.034,
    fill: "#d3c2a9"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15611",
    "data-name": "Group 15611",
    transform: "translate(12.47 8.469)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_148711",
    "data-name": "Rectangle 148711",
    width: 0.158,
    height: 13.034,
    fill: "#d3c2a9"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15612",
    "data-name": "Group 15612",
    transform: "translate(12.208 8.469)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_148712",
    "data-name": "Rectangle 148712",
    width: 0.157,
    height: 13.034,
    fill: "#d3c2a9"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15613",
    "data-name": "Group 15613",
    transform: "translate(11.945 8.469)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_148713",
    "data-name": "Rectangle 148713",
    width: 0.158,
    height: 13.034,
    fill: "#d3c2a9"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15614",
    "data-name": "Group 15614",
    transform: "translate(11.684 8.469)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_148714",
    "data-name": "Rectangle 148714",
    width: 0.157,
    height: 13.034,
    fill: "#d3c2a9"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15615",
    "data-name": "Group 15615",
    transform: "translate(11.421 8.469)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_148715",
    "data-name": "Rectangle 148715",
    width: 0.158,
    height: 13.034,
    fill: "#d3c2a9"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15616",
    "data-name": "Group 15616",
    transform: "translate(11.16 8.469)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_148716",
    "data-name": "Rectangle 148716",
    width: 0.157,
    height: 13.034,
    fill: "#d3c2a9"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15617",
    "data-name": "Group 15617",
    transform: "translate(10.897 8.469)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_148717",
    "data-name": "Rectangle 148717",
    width: 0.157,
    height: 13.034,
    fill: "#d3c2a9"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15618",
    "data-name": "Group 15618",
    transform: "translate(10.635 8.469)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_148718",
    "data-name": "Rectangle 148718",
    width: 0.157,
    height: 13.034,
    fill: "#d3c2a9"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15619",
    "data-name": "Group 15619",
    transform: "translate(10.373 8.469)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_148719",
    "data-name": "Rectangle 148719",
    width: 0.157,
    height: 13.034,
    fill: "#d3c2a9"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15620",
    "data-name": "Group 15620",
    transform: "translate(10.111 8.469)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_148720",
    "data-name": "Rectangle 148720",
    width: 0.157,
    height: 13.034,
    fill: "#d3c2a9"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15621",
    "data-name": "Group 15621",
    transform: "translate(9.849 8.469)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_148721",
    "data-name": "Rectangle 148721",
    width: 0.157,
    height: 13.034,
    fill: "#d3c2a9"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15622",
    "data-name": "Group 15622",
    transform: "translate(9.587 8.469)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_148722",
    "data-name": "Rectangle 148722",
    width: 0.157,
    height: 13.034,
    fill: "#d3c2a9"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15623",
    "data-name": "Group 15623",
    transform: "translate(9.325 8.469)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_148723",
    "data-name": "Rectangle 148723",
    width: 0.157,
    height: 13.034,
    fill: "#d3c2a9"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15624",
    "data-name": "Group 15624",
    transform: "translate(8.698 8.469)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_148724",
    "data-name": "Rectangle 148724",
    width: 0.157,
    height: 13.034,
    fill: "#d3c2a9"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15625",
    "data-name": "Group 15625",
    transform: "translate(8.435 8.469)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_148725",
    "data-name": "Rectangle 148725",
    width: 0.157,
    height: 13.034,
    fill: "#d3c2a9"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15626",
    "data-name": "Group 15626",
    transform: "translate(8.173 8.469)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_148726",
    "data-name": "Rectangle 148726",
    width: 0.157,
    height: 13.034,
    fill: "#d3c2a9"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15627",
    "data-name": "Group 15627",
    transform: "translate(7.911 8.469)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_148727",
    "data-name": "Rectangle 148727",
    width: 0.157,
    height: 13.034,
    fill: "#d3c2a9"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15628",
    "data-name": "Group 15628",
    transform: "translate(7.649 8.469)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_148728",
    "data-name": "Rectangle 148728",
    width: 0.157,
    height: 13.034,
    fill: "#d3c2a9"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15629",
    "data-name": "Group 15629",
    transform: "translate(7.387 8.469)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_148729",
    "data-name": "Rectangle 148729",
    width: 0.157,
    height: 13.034,
    fill: "#d3c2a9"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15630",
    "data-name": "Group 15630",
    transform: "translate(7.125 8.469)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_148730",
    "data-name": "Rectangle 148730",
    width: 0.157,
    height: 13.034,
    fill: "#d3c2a9"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15631",
    "data-name": "Group 15631",
    transform: "translate(6.863 8.469)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_148731",
    "data-name": "Rectangle 148731",
    width: 0.157,
    height: 13.034,
    fill: "#d3c2a9"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15632",
    "data-name": "Group 15632",
    transform: "translate(6.601 8.469)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_148732",
    "data-name": "Rectangle 148732",
    width: 0.158,
    height: 13.034,
    fill: "#d3c2a9"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15633",
    "data-name": "Group 15633",
    transform: "translate(6.339 8.469)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_148733",
    "data-name": "Rectangle 148733",
    width: 0.157,
    height: 13.034,
    fill: "#d3c2a9"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15634",
    "data-name": "Group 15634",
    transform: "translate(6.077 8.469)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_148734",
    "data-name": "Rectangle 148734",
    width: 0.158,
    height: 13.034,
    fill: "#d3c2a9"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15635",
    "data-name": "Group 15635",
    transform: "translate(5.815 8.469)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_148735",
    "data-name": "Rectangle 148735",
    width: 0.157,
    height: 13.034,
    fill: "#d3c2a9"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15636",
    "data-name": "Group 15636",
    transform: "translate(5.553 8.469)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_148736",
    "data-name": "Rectangle 148736",
    width: 0.157,
    height: 13.034,
    fill: "#d3c2a9"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15637",
    "data-name": "Group 15637",
    transform: "translate(5.29 8.469)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_148737",
    "data-name": "Rectangle 148737",
    width: 0.157,
    height: 13.034,
    fill: "#d3c2a9"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15638",
    "data-name": "Group 15638",
    transform: "translate(5.028 8.469)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_148738",
    "data-name": "Rectangle 148738",
    width: 0.157,
    height: 13.034,
    fill: "#d3c2a9"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15639",
    "data-name": "Group 15639",
    transform: "translate(4.793 8.469)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_148739",
    "data-name": "Rectangle 148739",
    width: 0.157,
    height: 13.034,
    fill: "#d3c2a9"
  }))), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "Path_14048",
    "data-name": "Path 14048",
    d: "M353.07,300.645l-.058-.029,38.388.118,1.573,3.529h-38.33Z",
    transform: "translate(-339.123 -297.38)",
    fill: "#7c4a28"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Group_15640",
    "data-name": "Group 15640",
    transform: "translate(7.466 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14049",
    "data-name": "Path 14049",
    d: "M344.011,296.056l-6.445-3.264H375.9l6.445,3.353H344.049Z",
    transform: "translate(-337.529 -292.792)",
    fill: "#a36d48"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14050",
    "data-name": "Path 14050",
    d: "M337.478,292.792h.036l-.036.019Z",
    transform: "translate(-337.478 -292.792)",
    fill: "#af894e"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_14051",
    "data-name": "Path 14051",
    d: "M359.3,310.744h36.058v-1.382H358.679Z",
    transform: "translate(-342.446 -302.51)",
    fill: "#c9c3bc",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "Path_14052",
    "data-name": "Path 14052",
    d: "M344.011,296.056l-6.445-3.264,14.827,3.353h-8.343Z",
    transform: "translate(-330.064 -292.792)",
    fill: "#fff",
    opacity: 0.2
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "Path_14053",
    "data-name": "Path 14053",
    d: "M413.792,292.792l13.254,3.353h-7.178Z",
    transform: "translate(-374.77 -292.792)",
    fill: "#fff",
    opacity: 0.2
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "Path_14054",
    "data-name": "Path 14054",
    d: "M358.679,292.792l28.767,3.353H364.912Z",
    transform: "translate(-342.446 -292.792)",
    fill: "#fff",
    opacity: 0.2
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_148740",
    "data-name": "Rectangle 148740",
    width: 36.058,
    height: 9.888,
    transform: "translate(16.85 11.586)",
    fill: "url(#linear-gradient)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "Group_15641",
    "data-name": "Group 15641",
    transform: "translate(15.975 0)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14055",
    "data-name": "Path 14055",
    d: "M365.915,299.674h.193l-1.561-3.593-.028-.014-6.205-3.274-.257.009,6.353,3.407Z",
    transform: "translate(-358.057 -292.792)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15642",
    "data-name": "Group 15642",
    transform: "translate(16.075 0)",
    opacity: 0.5,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    id: "Path_14056",
    "data-name": "Path 14056",
    d: "M366.156,299.674h.193l-1.561-3.593-.028-.014-6.2-3.274-.257.009,6.353,3.407Z",
    transform: "translate(-358.298 -292.792)",
    fill: "#c9c3bc"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "Group_15643",
    "data-name": "Group 15643",
    transform: "translate(38.646 0)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14057",
    "data-name": "Path 14057",
    d: "M420.74,299.674h.193l-1.561-3.593-.028-.014-6.2-3.274-.258.009,6.354,3.407Z",
    transform: "translate(-412.881 -292.792)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15644",
    "data-name": "Group 15644",
    transform: "translate(38.745 0)",
    opacity: 0.5,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    id: "Path_14058",
    "data-name": "Path 14058",
    d: "M420.981,299.674h.193l-1.561-3.593-.028-.014-6.2-3.274-.258.009,6.353,3.407Z",
    transform: "translate(-413.122 -292.792)",
    fill: "#c9c3bc"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "Group_15645",
    "data-name": "Group 15645",
    transform: "translate(7.466 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14059",
    "data-name": "Path 14059",
    d: "M337.514,292.792l-.036.019v-.019Z",
    transform: "translate(-337.478 -292.792)",
    fill: "#af894e"
  })))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "Group_15236",
    "data-name": "Group 15236",
    transform: "translate(159.486 279.166)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8818",
    "data-name": "Path 8818",
    d: "M384.106,1361.042q-.125,1.616-.408,3.363c0,.026-.009.052-.014.079-.1.6-.214,1.206-.34,1.817-.118.639-.275,1.313-.445,1.987-.079.327-.171.656-.249.984-.275,1.04-.589,2.114-.969,3.227-.118.365-.236.747-.367,1.113-.033.114-.071.229-.11.342H239.988l-.078-.288-.013-.036v-.018a.079.079,0,0,1-.013-.037c-.052-.145-.092-.31-.144-.51-.026-.092-.052-.2-.092-.311v-.037l-.013-.018c-.18-.65-.4-1.5-.66-2.521-.212-.844-.448-1.8-.7-2.875-.537-2.315-1.152-5.14-1.755-8.33-.236-1.258-.472-2.57-.694-3.938-.131-.79-.263-1.612-.389-2.442,12.945,4.884,46.235,15.859,70.009,9.721,4.272-1.1,8.986-2.09,13.932-2.972q1.658-.3,3.348-.577c12.824-2.131,26.845-3.608,38.594-4.626h0l.406-.035.4-.034.481-.041.992-.083.128-.01.753-.062q1.385-.115,2.716-.221l.6-.047.653-.052.869-.068.53-.041.934-.071.453-.034.617-.046.05,0,.993-.074.312-.023.014,0h.008c2.65-.2,5.029-.36,7.065-.5.357.428.7.865,1.028,1.315q.249.35.482.712a15.906,15.906,0,0,1,1.207,2.245,14.545,14.545,0,0,1,.62,1.709A14.348,14.348,0,0,1,384.106,1361.042Z",
    transform: "translate(-235.435 -1352.594)",
    fill: "#108757"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8819",
    "data-name": "Path 8819",
    d: "M1472.747,1464.351a38.239,38.239,0,0,0-14.934,15.188c-.031.059-.062.119-.093.178l-3.357-.178-1.05-.056c.1-.284,4.783-7.383,16.108-14.555Q1471.068,1464.631,1472.747,1464.351Z",
    transform: "translate(-1385.521 -1458.179)",
    fill: "#6e9e63"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8820",
    "data-name": "Path 8820",
    d: "M1580.785,1463.53c.107-.3,5.552-8.582,19-16.078l1.059.828a36.088,36.088,0,0,0-15.9,15.473Z",
    transform: "translate(-1505.894 -1442.213)",
    fill: "#6e9e63"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8821",
    "data-name": "Path 8821",
    d: "M1756.889,1463.53c.106-.3,5.552-8.582,19-16.078l1.059.828a36.087,36.087,0,0,0-15.9,15.473Z",
    transform: "translate(-1672.195 -1442.213)",
    fill: "#6e9e63"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8822",
    "data-name": "Path 8822",
    d: "M2062.443,1363.411s-18.849,1.918-30.62,14.044l-7.427-2.128c.206-.3,8.268-6.581,26.224-10.967h0c4.3-.375,8.3-.688,11.819-.949Z",
    transform: "translate(-1924.582 -1362.814)",
    fill: "#6e9e63"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8823",
    "data-name": "Path 8823",
    d: "M2146.524,1393.3c-8.467,2.044-22.021,6.729-32.157,16.991h-6.489l-4.768-1.38c.3-.468,13.225-11.28,42.215-17.856A15.914,15.914,0,0,1,2146.524,1393.3Z",
    transform: "translate(-1998.948 -1388.931)",
    fill: "#6e9e63"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFerme);
export default __webpack_public_path__ + "static/media/ferme.48e9acc9347dab032a1d66ebe2e764eb.svg";
export { ForwardRef as ReactComponent };